export enum CustomHeader {
  pageIndex = 'X-page-index',
  pageSize ='X-page-size',
  totalCount = 'X-total-count'
}
